const parseHiddenStaffIds = () => {
  const raw = process.env.REACT_APP_LEADERBOARD_HIDDEN_STAFF_IDS || ''

  return raw
    .split(',')
    .map((value) => value.trim())
    .filter(Boolean)
}

export const HIDDEN_LEADERBOARD_STAFF_IDS = parseHiddenStaffIds()

export const getLeaderboardStaffId = (staff) => {
  return staff?.staff_id ?? staff?.id ?? null
}

export const isHiddenLeaderboardStaff = (staff) => {
  const id = getLeaderboardStaffId(staff)
  if (id == null) return false
  return HIDDEN_LEADERBOARD_STAFF_IDS.includes(String(id))
}

export const filterVisibleLeaderboardStaff = (list = []) => {
  return list.filter((staff) => !isHiddenLeaderboardStaff(staff))
}
